import { createContext, useCallback, useContext } from 'react';
// @ts-expect-error untyped dependency
import { generateLead } from '../clients/ecosystemClient';
import { jsx as _jsx } from "react/jsx-runtime";
const LeadGenContext = /*#__PURE__*/createContext(undefined);
export const LeadGenProvider = ({
  children,
  offeringId,
  homemade,
  isPreview = false
}) => {
  const sendLead = useCallback(() => {
    if (!isPreview && offeringId) {
      try {
        generateLead(offeringId);
      } catch (error) {
        console.error('Error sending lead:', error);
      }
    }
  }, [isPreview, offeringId]);
  const runLeadGen = useCallback(() => {
    if (!homemade) {
      sendLead();
    }
  }, [homemade, sendLead]);
  return /*#__PURE__*/_jsx(LeadGenContext.Provider, {
    value: {
      sendLead,
      runLeadGen
    },
    children: children
  });
};
export const useLeadGenContext = () => {
  const context = useContext(LeadGenContext);
  if (!context) {
    throw new Error('useLeadGenContext must be used within a LeadGenContext.Provider');
  }
  return context;
};